export enum ErrorRoutes {
  Error = '/error',
}
